// @core/api/endpoints/notifications/update_user_settings_global.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateUserSettingsGlobalRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update user global notification settings
 * Updates the user's global notification preferences. Changes apply to all notification types unless overridden by event-specific settings.
 */
export async function UpdateUserSettingsGlobal(
  user_id: string,
  data: UpdateUserSettingsGlobalRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/settings`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
